<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="toolbar">
            <div class="row" style="margin-right: 0px; margin-left: 0px">
              <div class="col-md-12">
                <input type="text" class="form-control" style="height: 34px" placeholder="Pesquisar..."
                  [(ngModel)]="pesquisa" (keyup.enter)="pesquisar()" />
              </div>
            </div>
            <div class="row" style="margin-right: 0px; margin-left: 0px; text-align: right">
              <div class="col-md-12" style="text-align: right">
                <div style="margin-top: 5px !important; float: right">
                  <div class="" id="button-addon4" style="text-align: right">
                    <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px" (click)="pesquisar()">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px" (click)="atualizar()">
                      <i class="fa fa-refresh"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-2">
                <label for="mat_gestor">Matricula Gestor</label>
                        <ng-autocomplete 
                        id="mat_gestor"
                        [data]="dataGestor"
                        [searchKeyword]="keywordMatGestor"
                        (selected)='selectMatGestor($event)'
                        [itemTemplate]="itemTemplateMatGestor"
                        [notFoundTemplate]="notFoundTemplateMatGestor">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMatGestor let-item>
                        <a [innerHTML]="item.nome"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateMatGestor let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-2">
                <label for="mat_gestor">Matricula do Usuário</label>
                    
                        <ng-autocomplete 
                        id="mat_gestor"
                        [data]="data"
                        [searchKeyword]="keywordMatUser"
                        (selected)='selectMatUser($event)'
                        [itemTemplate]="itemTemplateMatUser"
                        [notFoundTemplate]="notFoundTemplateMatUser">                                 
                      </ng-autocomplete>
                      
                      <ng-template #itemTemplateMatUser let-item>
                        <a [innerHTML]="item.nome"></a>
                      </ng-template>
                      
                      <ng-template #notFoundTemplateMatUser let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>
              </div>
            </div>

          </div>
          <hr />
          <div class="table-responsive table-hover" style="overflow-y: hidden; overflow-x: auto">
            <table class="table" *ngIf="!loading">
              <thead class="">
                <tr>
                  <th scope="col">Numero Mov.</th>
                  <th>Nr. Patrimonio</th>
                  <th>Descrição do bem</th>
                  <th>Nome do Responsavel</th>
                  <th>Matricula do Usuário</th>
                  <th colspan="4" class="actions text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let ev of page.dados">

                  <td>{{ev.cD_BPM_MOVIMENTACAO_PATRIMONIAL}}</td>
                  <td>{{ev.nR_BPM_BEM_PATRIMONIAL}}</td>
                  <td>{{ev.dS_BPM_DESCRICAO_BEM}}</td>
                  <td>{{ev.dS_NM_ORIGEM}}</td>
                  <td>{{ev.cD_CDU_MATRICULA_ORIGEM}}</td>
                  <td class="actions text-center">
                    <a class="btn btn-icon btn-neutral btn-twitter" (click)="abreEdicao(ev.nR_BPM_BEM_PATRIMONIAL,ev.cD_BPM_MOVIMENTACAO_PATRIMONIAL)">
                      <i class="fa fa-edit"></i>
                    </a>
                  </td>
              </tbody>
            </table>
            <div class="row" *ngIf="page.dados && !loading">
              <div class="col-md-12">
                <ul class="pagination" *ngIf="page.pages.length > 0">
                  <li class="page-item" [ngClass]="{ disabled: page.currentPage === 1 }" title="Primeira página">
                    <a class="page-link" aria-label="Primeira página" (click)="setPage(1)">
                      <span aria-hidden="true"><i class="fa fa-angle-double-left" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li class="page-item" title="Página anterior" [ngClass]="{ disabled: page.currentPage === 1 }">
                    <a class="page-link" aria-label="Página anterior" (click)="setPage(page.currentPage - 1)">
                      <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li *ngFor="let page of page.pages" class=""
                    [ngClass]="{ 'page-item': true, active: paginaAtual(page)}" [attr.title]="'Página ' + page">
                    <a class="page-link" (click)="setPage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" title="Próxima página" [ngClass]="{
                  disabled: page.currentPage === page.totalPages
                }">
                    <a class="page-link" aria-label="Próxima página" (click)="setPage(page.currentPage + 1)">
                      <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
                    </a>
                  </li>
                  <li class="page-item" title="Última página"
                    [ngClass]="{ disabled: page.currentPage === page.totalPages }">
                    <a class="page-link" aria-label="Última página" (click)="setPage(page.totalPages)">
                      <span aria-hidden="true"><i class="fa fa-angle-double-right" aria-hidden="true"></i></span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="loading">
                <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="page.dados?.length == 0 && !loading">
                <h5>Não há dados para exibir</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>